import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TargetingAdminStore } from '../../../stores';
import { IAPanel } from '../../../../panels/Panel';
import { IATextField } from '../../../../textField/TextField';
import * as styles from "./Panel.css";
import { IAPeopleSearch } from '../../../../peopleSearch/PeopleSearch';
import { TargetingService } from '../../../../../services/TargetingService';
import { IUser } from '../../../../../interfaces/IUser';

import { IAButton } from '../../../../button/Button';
import { LocalizationService } from '../../../../../services/LocalizationService';
import { IAMessageBar } from '../../../../messageBar/MessageBar';

export interface IProps {
  targetingStore?: TargetingAdminStore;
  reloadGroups: () => void;
}

export interface IState {
  showErrorMessage?: string;
}

@inject('targetingStore')
@observer
export default class EditPanel extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props, state) {
    super(props, state);
    this.state = {
    }
  }

  private selectedPeople = (people: IUser[]) => {
    if (people && people.length > 0) {
      this.props.targetingStore.userGroupToEdit.values = JSON.stringify(people);
    } else {
      this.props.targetingStore.userGroupToEdit.values = undefined;
    }
  }

  private save = (): Promise<void> => {
    return new Promise<void>((resolve: () => void): void => {

      if (this.props.targetingStore.userGroupToEdit.title && this.props.targetingStore.userGroupToEdit.values) {
        if (this.props.targetingStore.creatingNew) {
          TargetingService.createGroup(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token, this.props.targetingStore.userGroupToEdit).then((status: number) => {
            this.props.targetingStore.isSaving = false;
            switch (status) {
              case 200:
              case 204:
                this.props.reloadGroups(); // Reloading groups when creating it
                this.props.targetingStore.userGroupToEdit = undefined;
                resolve();
                break;
              default:
                this.setState({ showErrorMessage: this.localizationService.strings.TargetingAdmin_ErrorCreatingADGroup });
                break;
            }
          });
        } else {
          TargetingService.updateGroup(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token, this.props.targetingStore.userGroupToEdit, this.props.targetingStore.userGroupToEdit.id).then((status: number) => {
            switch (status) {
              case 200:
              case 204:
                this.props.reloadGroups(); // Reloading groups when updating it
                this.props.targetingStore.userGroupToEdit = undefined;
                resolve();
                break;
              default:
                this.setState({ showErrorMessage: this.localizationService.strings.TargetingAdmin_ErrorUpdatingADGroup });
                break;
            }
            resolve();
          });
        }
      }
    });
  }


  public render(): JSX.Element {

    let editContent: JSX.Element;

    if (this.props.targetingStore.userGroupToEdit !== undefined) {
      editContent = (
        <div className={styles.IA_viewPanelContentWrapper}>
          {this.state.showErrorMessage &&
            <IAMessageBar
              type="error"
              onDismiss={() => {
                this.setState({ showErrorMessage: undefined });
              }}
              content={this.state.showErrorMessage}
              showIcon={false}
              showCloseButton={false}
              style={{
                marginTop: 20,
                width: "100%"
              }}
            />
          }
          <IATextField
            label={this.localizationService.strings.TargetingAdmin_UserGroup_EditPanel_Title}
            text={this.props.targetingStore.userGroupToEdit.title}
            borderRadius={5}
            maxLength={50}
            toolTipText={this.localizationService.strings.TargetingAdmin_ColoumName}
            placeholder={this.localizationService.strings.TargetingAdmin_UserGroup_EditPanel_Title}
            onChange={(title: string) => {
              this.props.targetingStore.userGroupToEdit.title = title;
            }}
          />
          <div
            style={{
              marginTop: 20,
              clear: "both",
              float: "left",
              width: "100%"
            }}
          >
            <label>{this.localizationService.strings.TargetingAdmin_UserGroup_EditPanel_Values}</label>
            <div
              style={{
                marginTop: 7
              }}
            >
              <IAPeopleSearch
                environment={this.props.targetingStore.environment}
                multiSelection={true}
                onSelect={(people) => { this.selectedPeople(people); }}
                selectedValues={this.props.targetingStore.userGroupToEdit.values ? JSON.parse(this.props.targetingStore.userGroupToEdit.values) : null}
                tenant={this.props.targetingStore.tenant}
                token={this.props.targetingStore.token}
                showGroups={true}
              />
            </div>
          </div>
          <div style={{ float: 'left', position: 'absolute', bottom: '0', marginBottom: '20px' }}>
            <IAButton
              style={{ float: 'left' }}
              borderRadius={5}
              buttonColor={this.props.targetingStore.highlightColor}
              label={this.localizationService.strings.TargetingAdmin_ApplicationSettingsSave}
              showSpinner={this.props.targetingStore.isSaving}
              disbaled={(this.props.targetingStore.userGroupToEdit.title && this.props.targetingStore.userGroupToEdit.values) && !this.props.targetingStore.isSaving ? false : true}
              // icon={"Synchronize"}
              onClick={() => {
                this.setState({ showErrorMessage: undefined });
                this.props.targetingStore.isSaving = true;
                this.save().then(() => {
                  if (this.props.targetingStore.creatingNew) {
                    TargetingService.getGroups(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then((groups) => {
                      this.props.targetingStore.transformDataToGroupList(groups);
                      this.updateApplicationsData().then(() => {
                        this.props.targetingStore.creatingNew = false;
                        this.props.targetingStore.isSaving = false;
                      });
                    });
                  } else {
                    this.props.targetingStore.isSaving = false;
                  }
                  document.body.style.height = "inherit";
                  document.body.style.overflowY = "auto";
                });
              }}
            />
            {this.props.targetingStore.userGroupToEdit.id &&
              <IAButton
                label={this.localizationService.strings.Admin_Delete}
                buttonColor={"red"}
                borderRadius={5}
                style={{ marginLeft: "10px", float: 'right' }}
                onClick={() => {
                  this.setState({ showErrorMessage: undefined });
                  this.props.targetingStore.userGroupToDelete = this.props.targetingStore.userGroupToEdit;
                }}
              />
            }
            <IAButton
              label={this.localizationService.strings.TargetingAdmin_PropertyPanelCancel}
              buttonColor={"#999999"}
              borderRadius={5}
              style={{ marginLeft: "10px", float: 'right' }}
              onClick={() => {
                this.setState({ showErrorMessage: undefined });
                if (JSON.stringify(this.props.targetingStore.userGroupToEdit) !== JSON.stringify(this.props.targetingStore.originalUserGroupToEdit)) {
                  this.props.targetingStore.showCancelEditPopup = true;
                } else {
                  this.props.targetingStore.userGroupToEdit = undefined;
                  this.props.targetingStore.creatingNew = false;
                }
              }}
            />
          </div>
        </div>
      );
    }

    return (
      <div>
        <IAPanel
          showNavigationBar={true}
          itemId={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.id !== undefined ? this.props.targetingStore.userGroupToEdit.id : undefined}
          open={this.props.targetingStore.userGroupToEdit != undefined}
          transition={this.props.targetingStore.userGroupToEdit != undefined ? "fade" : "slide"}
          width={550}
          isMobile={false}
          tenant={this.props.targetingStore.tenant}
          token={this.props.targetingStore.token}
          environment={this.props.targetingStore.environment}
          disableSaving={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title === undefined
            || this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title == ""
          }
          // Actions
          close={() => {
            this.setState({ showErrorMessage: undefined });
            if (JSON.stringify(this.props.targetingStore.userGroupToEdit) !== JSON.stringify(this.props.targetingStore.originalUserGroupToEdit)) {
              this.props.targetingStore.showCancelEditPopup = true;
            } else {
              this.props.targetingStore.userGroupToEdit = undefined;
              this.props.targetingStore.creatingNew = false;
            }
          }}
        >{editContent}</IAPanel>
      </div>
    );
  }


  private updateApplicationsData = (): Promise<void> => {
    return new Promise<void>((resolve: () => void): void => {
      let listObjects = [];
      this.props.targetingStore.applicationsData.forEach(application => {
        let hasUpdate = false;
        if (application.default.type === "userGroups") {
          if (application.default.allValues) {
            let userGroups = this.props.targetingStore.groupsList.map((group) => {
              let storedGroup = application.default.values.find(g => g.id === group.id);
              return { label: group.title, id: group.id, value: application.default.allValues ? true : ((storedGroup && storedGroup.value) ? storedGroup.value : false) };
            });
            application.default.values = userGroups;
            hasUpdate = true;
          }
        }
        application.instances.forEach(instance => {
          if (instance.type === "userGroups") {
            if (instance.allValues) {
              let userGroups = this.props.targetingStore.groupsList.map((group) => {
                let storedGroup = instance.values.find(g => g.id === group.id);
                return { label: group.title, id: group.id, value: instance.allValues ? true : ((storedGroup && storedGroup.value) ? storedGroup.value : false) };
              });
              instance.values = userGroups;
              hasUpdate = true;
            }
          }
        });
        if (hasUpdate) {
          let applicationObject = {
            id: application.id,
            title: application.title,
            applicationSettings: application.default.type === 'userGroups' ? 'User groups' : 'Profile data',
            defaultValues: JSON.stringify(application)
          };
          listObjects.push(applicationObject);
        }
      });
      if (listObjects.length > 0) {
        TargetingService.updateApplicationsGroupsAndProfileData(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token,
          listObjects).then(() => {
            resolve();
          });
      } else {
        resolve();
      }
    });
  }
}